import { Header } from "../SignUp/partials/Header";
import { Footer } from "../SignUp/partials/Footer";
import { Container } from "../SignUp/partials/Container";
import { ResetPasswordForm } from "./partials/ResetPasswordForm";
import { useState } from "react";
import Fade from "@mui/material/Fade";
import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const [resetEmail, setResetEmail] = useState("");

  const navigate = useNavigate();

  return (
    <Container>
      <Fade in={!!resetEmail} timeout={1000}>
        <Stack
          width="100%"
          alignItems="center"
          display={!!resetEmail ? "flex" : "none"}
        >
          <Header
            disableCompanyIdentity
            title="Check your email"
            subtitle={`Reset link sent to this email: ${resetEmail}`}
          />
          <Button variant="text" onClick={() => navigate("/login")}>
            Return to Login
          </Button>
        </Stack>
      </Fade>
      <Fade in={!resetEmail} timeout={1000}>
        <Stack width="100%" display={!resetEmail ? "flex" : "none"}>
          <Header
            disableCompanyIdentity
            title="Forgot password?"
            subtitle="Enter your email address and we’ll send you a link to reset your password"
          />
          <ResetPasswordForm onSuccess={({ email }) => setResetEmail(email)} />
          <Footer
            text="Don’t want to reset?"
            linkText="Sign In"
            link="/login"
          />
        </Stack>
      </Fade>
    </Container>
  );
};

export default ResetPassword;
